var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c(
        "base-alert",
        {
          attrs: { variant: _vm.$store.state.video.alert.variant },
          model: {
            value: _vm.$store.state.video.alert.visible,
            callback: function($$v) {
              _vm.$set(_vm.$store.state.video.alert, "visible", $$v)
            },
            expression: "$store.state.video.alert.visible"
          }
        },
        [_vm._v("\n    " + _vm._s(_vm.$store.state.video.alert.text) + "\n  ")]
      ),
      _vm._v(" "),
      _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fbf8a0d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fbf8a0d0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/video-launcher/VideoLayout.vue
// module id = 1737
// module chunks = 116